/**
 * Текущая валюта
 */
export const currentCurrency = (window.app && window.app.currentCurrency)
                               || { 'name': 'RUB', 'sign': '<span class=\'rur\'>руб.</span>' }
